var exports = {
  "R_": "x1cb7f6e3--67fb00--heading",
  "OL": "x1cb7f6e3--67fb00--heading__wrapper",
  "Pc": "x1cb7f6e3--67fb00--listing__card",
};

module.exports = exports;
